import { render, staticRenderFns } from "./add-campaign-members.vue?vue&type=template&id=641c94e4&scoped=true&"
import script from "./add-campaign-members.vue?vue&type=script&lang=js&"
export * from "./add-campaign-members.vue?vue&type=script&lang=js&"
import style0 from "./add-campaign-members.vue?vue&type=style&index=0&id=641c94e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c94e4",
  null
  
)

export default component.exports